var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10777 6.51169C7.93814 6.7473 7.87499 7.0503 7.87499 7.24229C7.87499 7.61508 7.57278 7.91729 7.19999 7.91729C6.8272 7.91729 6.52499 7.61508 6.52499 7.24229C6.52499 6.83427 6.64184 6.23727 7.0122 5.72288C7.40735 5.17407 8.05999 4.76729 8.99999 4.76729C9.93998 4.76729 10.5926 5.17407 10.9878 5.72288C11.3581 6.23727 11.475 6.83427 11.475 7.24229C11.475 7.6503 11.3581 8.2473 10.9878 8.76169C10.6953 9.16791 10.2617 9.49632 9.67499 9.63955V10.3923C9.67499 10.7651 9.37278 11.0673 8.99999 11.0673C8.6272 11.0673 8.32499 10.7651 8.32499 10.3923V9.04229C8.32499 8.66949 8.6272 8.36729 8.99999 8.36729C9.49999 8.36729 9.74734 8.17407 9.8922 7.97288C10.0618 7.73727 10.125 7.43427 10.125 7.24229C10.125 7.0503 10.0618 6.7473 9.8922 6.51169C9.74734 6.3105 9.49999 6.11729 8.99999 6.11729C8.49998 6.11729 8.25263 6.3105 8.10777 6.51169Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 13.3173C9.37278 13.3173 9.67499 13.0151 9.67499 12.6423C9.67499 12.2695 9.37278 11.9673 8.99999 11.9673C8.6272 11.9673 8.32499 12.2695 8.32499 12.6423C8.32499 13.0151 8.6272 13.3173 8.99999 13.3173Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99999 16.2423C12.9764 16.2423 16.2 13.0187 16.2 9.04229C16.2 5.06584 12.9764 1.84229 8.99999 1.84229C5.02354 1.84229 1.79999 5.06584 1.79999 9.04229C1.79999 13.0187 5.02354 16.2423 8.99999 16.2423ZM8.99999 14.8923C12.2309 14.8923 14.85 12.2732 14.85 9.04229C14.85 5.81142 12.2309 3.19229 8.99999 3.19229C5.76912 3.19229 3.14999 5.81142 3.14999 9.04229C3.14999 12.2732 5.76912 14.8923 8.99999 14.8923Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcn);
export default __webpack_public_path__ + "static/media/QuestionIcn.6f2a2e7030befda87a9036f84ee5d69c.svg";
export { ForwardRef as ReactComponent };